import {type FC, useEffect, useState} from 'react';
import callApi from '../../apis/callApi.ts';
import {load} from '@fingerprintjs/fingerprintjs';
import {ConfirmButton, Container, InputBox, MessageBox, Wrapper} from './DeviceIDError.styled.ts';
import useCenterStore from '../../store/useCenterStore.ts';
import error_img from '../../assets/error/error2_small.png';

const DeviceIDError: FC = () => {
    const [fingerPrintId, setFingerPrintId] = useState<string>('');
    const {centerInfo, setCenterInfo, deviceID, setDeviceID} = useCenterStore();

    const getDeviceFingerprint = async () => {
        const fp = await load();
        const result = await fp.get();
        const deviceFingerprint = result.visitorId;
        setFingerPrintId(deviceFingerprint);
    };

    useEffect(() => {
        if (localStorage.getItem('deviceID')) {
            getDeviceFingerprint();
            setDeviceID(localStorage.getItem('deviceID')!);
        }
    }, []);

    const postCenter = async () => {
        const center_code = centerInfo!.center_id;
        const settop_sn = deviceID;
        const finger_print_id = fingerPrintId;
        const data = {
            center_code,
            settop_sn,
            finger_print_id,
        };
        await callApi().post('/center-info/', data);
    };

    const getCheckDevice = async () => {
        try {
            window.location.href = `${import.meta.env.VITE_AUTH_API_URL}html/?device_id=${deviceID}`;
            // const res = await callApi().get(`/center-info/?settop_sn=${deviceID}`);
            // setCenterInfo(res.data);
            // navigate(`/streaming?deviceID=${deviceID}`);
        } catch (e: any) {
            const centerInfo = localStorage.getItem('centerInfo');
            console.log('[ERROR]: ', {error: e, centerInfo});
            if (centerInfo) {
                setCenterInfo(JSON.parse(centerInfo));
                await postCenter();
            }
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            getCheckDevice();
        }
    };

    return (
        <>
            <Container>
                <Wrapper>
                    <MessageBox>
                        <img src={error_img} alt="device id 에러" />
                    </MessageBox>
                    {/*<PhoneBox>*/}
                    {/*    <span>콜센터:</span> {phoneNumber}*/}
                    {/*</PhoneBox>*/}
                    {/*<InputBox>*/}
                    {/*    <label>경로당 ID:</label>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        value={centerInfo?.center_id ?? ""}*/}
                    {/*        onChange={(e) => setDeviceID(e.target.value)}*/}
                    {/*    />*/}
                    {/*</InputBox>*/}
                    <InputBox>
                        <label>경로당 ID:</label>
                        <input
                            type="text"
                            style={{}}
                            value={deviceID}
                            onChange={(e) => setDeviceID(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </InputBox>
                    <ConfirmButton onClick={getCheckDevice}>확 인</ConfirmButton>
                </Wrapper>
            </Container>
        </>
    );
};

export default DeviceIDError;
